import { render, staticRenderFns } from "./editEntityupdate.vue?vue&type=template&id=b2912e08&scoped=true"
import script from "./editEntityupdate.vue?vue&type=script&lang=js"
export * from "./editEntityupdate.vue?vue&type=script&lang=js"
import style0 from "./editEntityupdate.vue?vue&type=style&index=0&id=b2912e08&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2912e08",
  null
  
)

export default component.exports